import type { CurrentPayRate } from '../types';
import { formatVnd } from './money';

// "Giảng dạy 400.000 ₫/ca · Trợ giảng 300.000 ₫/ca" for one shift type; '' when neither is set.
export function describePayRate(rate: CurrentPayRate) {
    return [
        rate.teacher !== null ? `Giảng dạy ${formatVnd(rate.teacher)}/ca` : null,
        rate.assistant !== null ? `Trợ giảng ${formatVnd(rate.assistant)}/ca` : null,
    ].filter(Boolean).join(' · ');
}

// Only the shift types the person has a rate for.
export function setPayRates(rates: CurrentPayRate[] | undefined) {
    return (rates ?? []).filter(rate => rate.teacher !== null || rate.assistant !== null);
}
